import type {
  ImportableItemDetailsQueryKey,
  UseImportableItemDetailsParams,
} from './types';

export const getImportableItemDetailsQueryKey = (
  params: UseImportableItemDetailsParams,
): ImportableItemDetailsQueryKey => [
  'quotes',
  'importHistoricalWork',
  'importableItemDetails',
  params,
];
